export default "__VITE_ASSET__B_3aSqvn__"